/**
 * @description disable /cart page, byt redirecting to / and triggering cart drawer
 */
(function() {

    var path = window.location.pathname;
    var illegal = '/cart';
    var destination = '?cart';
    
    function redirect( illegal, destination ) {
        if ( path == illegal ) {
            window.location.href = `/${ destination }`;
        }
    }
    
    function triggerDrawerByQuery( query ) {
        var search = window.location.search;
        
        if ( search == query ) {
          	setTimeout(function(){ 
            	document.querySelector(`[href="${ illegal }"`).click();
            }, 1000);
        }
    }
    
    redirect(illegal, destination);
    triggerDrawerByQuery(destination);
    
})()

// update barcode on variant select
document.addEventListener("DOMContentLoaded", (event) => {
      let variantsLiElements = document.querySelectorAll(".clickyboxes.options-st-rrelse li");
      console.log(variantsLiElements)    
  
  const pluNumberValsElements = document.querySelectorAll("select#product-select option");
      const pluSpanElement = document.querySelector("span#barcode");
      const skuSpanElement = document.querySelector("span#sku");

      if(variantsLiElements.length > 0) {
        for(let i = 0; i < variantsLiElements.length; i++) {
          const aElement = variantsLiElements[i].querySelector("a");
          if(aElement.className.split(' ').includes("unavailable")) {
            variantsLiElements[i].style.display = "none"; 
          }

          // update the plu dom element when a variant is changed
          aElement.addEventListener("click", () => {
            const clickedVariantValue = aElement.dataset.value;

            let clickedVariantPluValue = undefined;
            let variantSkuValue = undefined;
            for(let j = 0; j < pluNumberValsElements.length; j++) {
              const matchingVariantValue = pluNumberValsElements[j].dataset.value === clickedVariantValue
              if(matchingVariantValue) {
                clickedVariantPluValue = pluNumberValsElements[j].dataset.plu;
                variantSkuValue = pluNumberValsElements[j].dataset.sku;
              }
            }

            if(clickedVariantPluValue !== undefined) {
              pluSpanElement.innerHTML = clickedVariantPluValue
              skuSpanElement.innerHTML = variantSkuValue
            }
          })
        }
      }
    });

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

$(document).bind("cbox_complete", async function () {
  // hack that will work until we move to new theme
  await sleep(100)
  
  const previewProductDialog = document.getElementById("cboxLoadedContent");
  
  let variantsLiElements = previewProductDialog.querySelectorAll(
    ".clickyboxes.options-st-rrelse li"
  );

  const pluNumberValsElements = previewProductDialog.querySelectorAll(
    "select#product-select option"
  );
  const pluSpanElement = previewProductDialog.querySelector("span#barcode");

  if (variantsLiElements.length > 0) {
    for (let i = 0; i < variantsLiElements.length; i++) {
      const aElement = variantsLiElements[i].querySelector("a");
      if (aElement.className.split(" ").includes("unavailable")) {
        variantsLiElements[i].style.display = "none";
      }

      // update the plu dom element when a variant is changed
      aElement.addEventListener("click", () => {
        const clickedVariantValue = aElement.dataset.value;

        let clickedVariantPluValue = undefined;
        for (let j = 0; j < pluNumberValsElements.length; j++) {
          const matchingVariantValue =
            pluNumberValsElements[j].dataset.value === clickedVariantValue;
          if (matchingVariantValue) {
            clickedVariantPluValue = pluNumberValsElements[j].dataset.plu;
          }
        }

        if (clickedVariantPluValue !== undefined) {
          pluSpanElement.innerHTML = clickedVariantPluValue;
        }
      });
    }
  }
});
